import React from 'react';
import { useTranslation } from 'react-i18next';

const ReceiptSummary = ({receipt}:any) =>{
    const {t} = useTranslation();
    return(
        <React.Fragment>
            <div><strong>{t('Receipt.total_gross_amount')}:</strong> {receipt.total_gross_amount}
            </div>
            <div><strong>{t('Receipt.total_tax')}:</strong> {receipt.total_tax}</div>
            <div><strong>{t('Receipt.total')}:</strong> {receipt.total}</div>
            <div>
                <strong>{t('Receipt.tender_type')}:</strong> {t(`TenderTypes.${receipt.tender_type}`)}
            </div>
            {receipt.credit_card && (
                <div><strong>{t('Receipt.credit_card')}:</strong> {receipt.credit_card}</div>
            )}
        </React.Fragment>
    )
}
export default ReceiptSummary;